import React, { useEffect, useState } from "react";
import AddChamberPopup from "../Component/AddChamberPopup";
import { API_BASE_URL } from "../config";
export default function Chamber(){
    const [chambers, setChambers] = useState([]);
    const [setNewChamber] = useState({ courtName: "", location: "" });
    const [editingChamber, setEditingChamber] = useState(null);

    // Fetch all chambers
      useEffect(() => {
        fetchChambers();
      }, []);

    const fetchChambers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://AdvocateAPI.codelovertechnology.com/api/ChamberMaster/GetChember", {
          headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setChambers(data);
      } else {
        console.error("Failed to fetch chamber");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };
// Add new chamber
  const handleAddChamber = async (newChamber) => {
    // e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/ChamberMaster/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newChamber),
      });
      if (res.ok) {
        fetchChambers(); // Refresh list
        setNewChamber({ courtName: "", location: "" });
        alert("Chamber added successfully!");
      } else {
        console.error("Failed to add chamber");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Delete court
  const handleDeleteChamber = async (id) => {
    if (!window.confirm("Are you sure you want to delete this chamber?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setChambers((prev) => prev.filter((c) => c.id !== id));
        alert("Court deleted successfully!");
      } else {
        console.error("Failed to delete court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update court
  const handleUpdateChamber = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/ChamberMaster/update/${editingChamber.chamberId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingChamber),
      });
      if (res.ok) {
        fetchChambers();
        setEditingChamber(null);
        alert("Chamber updated successfully!");
      } else {
        console.error("Failed to update chamber");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };


return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Chambers</h2>      
      <AddChamberPopup onAddChamber={handleAddChamber} />

      {/* Court Table */}
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Chamber Name</th>
            <th>Court Name</th>
            <th>judge Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {chambers.length > 0 ? (
            chambers.map((chamber) => (
              <tr key={chamber.chamberId}>
                <td>
                  {editingChamber?.chamberId === chamber.chamberId ? (
                    <input
                      type="text"
                      value={editingChamber.chamberName}
                      onChange={(e) =>
                        setEditingChamber({ ...editingChamber, chamberName: e.target.value })
                      }
                    />
                  ) : (
                    chamber.chamberName
                  )}
                </td>
                <td>
                  {editingChamber?.chamberId === chamber.chamberId ? (
                    <input
                      type="text"
                      value={editingChamber.courtName}
                      onChange={(e) =>
                        setEditingChamber({ ...editingChamber, courtName: e.target.value })
                      }
                    />
                  ) : (
                    chamber.courtName
                  )}
                </td>
                <td>
                  {editingChamber?.chamberId === chamber.chamberId ? (
                    <input
                      type="text"
                      value={editingChamber.judgeName}
                      onChange={(e) =>
                        setEditingChamber({ ...editingChamber, judgeName: e.target.value })
                      }
                    />
                  ) : (
                    chamber.judgeName
                  )}
                </td>
                <td>
                  {editingChamber?.chamberId === chamber.chamberId ? (
                    <>
                      <button onClick={handleUpdateChamber}>Save</button>
                      <button onClick={() => setEditingChamber(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditingChamber(chamber)}>Edit</button>
                      <button onClick={() => handleDeleteChamber(chamber.chamberId)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No Chamber found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

        
